<template>
  <div>
        <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据大屏</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单时间:">
        <el-date-picker
        v-model="datetimerange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        format="yyyy-MM-dd"
        :picker-options="pickerOptionArrays"
      />
    </el-form-item>
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.charging_stations_id" placeholder="请选择部门名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      </el-form>
      <el-row :gutter="20">
          <el-col :span="20">
              <el-row :gutter="24" class="mgb20">
                  <el-col :span="6">
                      <el-card shadow="hover" :body-style="{padding: '0px'}">
                          <div class="grid-content grid-con-1">
                              <i class="el-icon-data-analysis grid-con-icon"></i>
                              <div class="grid-cont-right">
                                  <div class="grid-num">{{ totalFee }}</div>
                                  <div>总营业额</div>
                              </div>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="6">
                      <el-card shadow="hover" :body-style="{padding: '0px'}">
                          <div class="grid-content grid-con-2">
                              <i class="el-icon-wind-power grid-con-icon"></i>
                              <div class="grid-cont-right">
                                  <div class="grid-num">{{ totalChargingNum }}</div>
                                  <div>总订单量</div>
                              </div>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="6">
                      <el-card shadow="hover" :body-style="{padding: '0px'}">
                          <div class="grid-content grid-con-3">
                              <i class="el-icon-bank-card grid-con-icon"></i>
                              <div class="grid-cont-right">
                                  <div class="grid-num">{{ todayFee }}</div>
                                  <div>今日营业额</div>
                              </div>
                          </div>
                      </el-card>
                  </el-col>
                  <el-col :span="6">
                      <el-card shadow="hover" :body-style="{padding: '0px'}">
                        <div class="grid-content grid-con-4">
                              <i class="el-icon-document-copy grid-con-icon"></i>
                              <div class="grid-cont-right">
                                  <div class="grid-num">{{ todayChargingNum }}</div>
                                  <div>今日订单量</div>
                              </div>
                          </div>
                      </el-card>
                  </el-col>
              </el-row>
          </el-col>
      </el-row>
      <el-row :gutter="20">
          <el-col :span="12">
              <el-card shadow="hover">
                <e-charts :option="options1" style="height: 280px" ref="chart1" ></e-charts>
              </el-card>
          </el-col>
          <el-col :span="12">
              <el-card shadow="hover">
                <e-charts :option="options2" style="height: 280px" ref="chart2" ></e-charts>
              </el-card>
          </el-col>
      </el-row>
      <el-row :gutter="20">
          <!-- <el-col :span="12">
              <el-card shadow="hover">
                <e-charts :option="options3" style="height: 280px" ref="chart3" ></e-charts>
              </el-card>
          </el-col> -->
          <el-col :span="12">
              <el-card shadow="hover">
                <e-charts :option="options4" style="height: 280px" ref="chart4" ></e-charts>
              </el-card>
          </el-col>
      </el-row>

  </div>
</template>

<script>
// import 'echarts'
// import {ECharts} from 'vue-echarts/components/ECharts'
import { getStationNames } from '../../api/station'
import { getDashboard,getChart } from '../../api/menu'

import moment from "moment";
export default {
  data() {
      return {
        totalFee:0,
        todayFee:0,
        totalChargingNum:0,
        todayChargingNum:0,
        options1:{
          title: {
            text: '营业额（元）'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: []
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: []
        },
        options2:{
          title: {
            text: '订单量'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: []
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: []
        },
        options3:{
          title: {
            text: '用户量'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: []
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: []
        },
        options4:{
          title: {
            text: '设备情况'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: []
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [],
              type: 'bar'
            }
          ]
        },
        pickerOptionArrays: {
          shortcuts: [{
            text: '当日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('day'));
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('isoWeek'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setTime(moment().startOf('month'));
              picker.$emit('pick', [start, end]);
            }
          }]
        },

      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() >= Date.now() - 3600 * 1000 * 24 * 1;
        },
      },
        // 请求数据参数
        datetimerange:[moment().add(-30, "days"),moment().add(0, "days")],
        formInline: {
          charging_stations_id:'',
          searchStartDate:'',
          searchEndDate:'',
        },
        station_names:[]
      };
  },
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },
  // components(){
  //   ECharts
  // },
  methods: {
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    search() {
      this.getdata(this.formInline)
    },
    getdata() {
      this.loading = true
      if(this.datetimerange[0]&&this.datetimerange[1]){
        this.formInline.searchStartDate = moment(this.datetimerange[0]).format("YYYY-MM-DD")
        this.formInline.searchEndDate = moment(this.datetimerange[1]).format("YYYY-MM-DD")
      }else{
          this.formInline.searchStartDate = this.datetimerange[0]
          this.formInline.searchEndDate = this.datetimerange[1]
      }
      this.formInline.chart_type = 'mount';
      this.formInline.token=localStorage.getItem('logintoken')
      getChart(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.options1.legend.data= res.data.legend
          this.options1.xAxis.data = res.data.apiXaxis
          this.options1.series = res.data.apiSeries
        } else {
          this.$message.error(res.message)
          return false
        }
      })
      this.formInline.chart_type = 'order';
      getChart(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.options2.legend.data= res.data.legend
          this.options2.xAxis.data = res.data.apiXaxis
          this.options2.series = res.data.apiSeries
        } else {
          this.$message.error(res.message)
          return false
        }
      })
      this.formInline.chart_type = 'user';
      getChart(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.options3.legend.data= res.data.legend
          this.options3.xAxis.data = res.data.apiXaxis
          this.options3.series = res.data.apiSeries
        } else {
          this.$message.error(res.message)
          return false
        }
      })
      this.formInline.chart_type = 'equipment';
      getChart(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.options4.xAxis.data = res.data.apiXaxis
          this.options4.series[0].data = res.data.apiSeries
        } else {
          this.$message.error(res.message)
          return false
        }
      })
      getDashboard(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.totalFee = res.data.totalFee
          this.todayFee= res.data.todayFee
          this.totalChargingNum = res.data.totalChargingNum
          this.todayChargingNum= res.data.todayChargingNum
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },

  }
};
</script>


<style scoped>
.el-row {
  margin-bottom: 20px;
}

.grid-content {
  display: flex;
  align-items: center;
  height: 100px;
}

.grid-cont-right {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
}

.grid-num {
  font-size: 30px;
  font-weight: bold;
}

.grid-con-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.grid-con-1 .grid-con-icon {
  background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
  color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
  background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
  color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
  background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
  color: rgb(45, 140, 240);
}

.grid-con-4 .grid-con-icon {
  background: #E6A23C;
}

.grid-con-4 .grid-num {
  color:  rgb(45, 140, 240);
}

.user-info {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
}

.user-avator {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.user-info-cont {
  padding-left: 50px;
  flex: 1;
  font-size: 14px;
  color: #999;
}

.user-info-cont div:first-child {
  font-size: 30px;
  color: #222;
}

.user-info-list {
  font-size: 14px;
  color: #999;
  line-height: 25px;
}

.user-info-list span {
  margin-left: 70px;
}

.mgb20 {
  margin-bottom: 20px;
}

.todo-item {
  font-size: 14px;
}

.todo-item-del {
  text-decoration: line-through;
  color: #999;
}

.schart {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue